import React, { useState, useEffect } from "react";

function formatFecha(val) {
  if (!val) return null;
  const raw = typeof val === "string" ? val.split("T")[0] : new Date(val).toISOString().split("T")[0];
  const [y, m, d] = raw.split("-");
  return `${d}/${m}/${y}`;
}

export default function ModalColaReservas({
  promocion,
  reservas,
  asignando,
  onAsignar,
  onCerrar,
}) {
  const [seleccionados, setSeleccionados] = useState([]);

  useEffect(() => {
    // Pre-seleccionar todos al abrir
    setSeleccionados(reservas.map(r => r.id));
  }, [reservas]);

  const toggleTodos = () => {
    if (seleccionados.length === reservas.length) {
      setSeleccionados([]);
    } else {
      setSeleccionados(reservas.map(r => r.id));
    }
  };

  const toggleUno = (id) => {
    setSeleccionados(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const todosSeleccionados = seleccionados.length === reservas.length && reservas.length > 0;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">

          <div className="modal-header" style={{ background: "var(--bs-primary, #0d6efd)", color: "white" }}>
            <h5 className="modal-title">
              <i className="bi bi-people-fill me-2" />
              Cola de espera — {reservas.length} estudiante{reservas.length !== 1 ? "s" : ""} con reserva
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onCerrar} />
          </div>

          <div className="modal-body">
            <div className="alert alert-info d-flex gap-2 align-items-start mb-3" style={{ fontSize: "0.875rem" }}>
              <i className="bi bi-info-circle-fill mt-1 flex-shrink-0" />
              <div>
                <strong>Promoción creada: {promocion.curso_nombre}</strong>
                {promocion.fecha_inicio && (
                  <span className="ms-2 text-muted">· Inicio {formatFecha(promocion.fecha_inicio)}</span>
                )}
                <br />
                Los siguientes estudiantes pagaron antes de que hubiera cupos disponibles.
                Selecciona a quiénes deseas asignar a esta nueva promoción. Recibirán un correo de confirmación automáticamente.
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: 40 }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={todosSeleccionados}
                        onChange={toggleTodos}
                      />
                    </th>
                    <th>#</th>
                    <th>Estudiante</th>
                    <th>Cédula</th>
                    <th>Contacto</th>
                    <th>Reservado el</th>
                  </tr>
                </thead>
                <tbody>
                  {reservas.map((r, idx) => (
                    <tr
                      key={r.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleUno(r.id)}
                    >
                      <td onClick={e => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={seleccionados.includes(r.id)}
                          onChange={() => toggleUno(r.id)}
                        />
                      </td>
                      <td className="text-muted">{idx + 1}</td>
                      <td>
                        <strong>{r.nombres} {r.apellidos}</strong>
                      </td>
                      <td className="text-muted">{r.num_cedula || "—"}</td>
                      <td className="text-muted" style={{ fontSize: "0.8rem" }}>
                        {r.email && <div><i className="bi bi-envelope me-1" />{r.email}</div>}
                        {r.celular && <div><i className="bi bi-phone me-1" />{r.celular}</div>}
                      </td>
                      <td className="text-muted" style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
                        {r.created_at ? formatFecha(r.created_at) : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {reservas.length === 0 && (
              <p className="text-muted text-center py-3">Sin reservas pendientes.</p>
            )}
          </div>

          <div className="modal-footer">
            <span className="text-muted me-auto" style={{ fontSize: "0.85rem" }}>
              {seleccionados.length} de {reservas.length} seleccionado{seleccionados.length !== 1 ? "s" : ""}
            </span>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCerrar}
              disabled={asignando}
            >
              Omitir por ahora
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={seleccionados.length === 0 || asignando}
              onClick={() => onAsignar(seleccionados)}
            >
              {asignando
                ? <><span className="spinner-border spinner-border-sm me-2" />Asignando...</>
                : <><i className="bi bi-check2-all me-2" />Asignar {seleccionados.length} a esta promoción</>
              }
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
